"use client";

import { motion, useReducedMotion } from "@/lib/motion";
import { scrollRevealViewport } from "@/lib/motion-viewport";
import { SectionHeader } from "@/components/ui";
import { USE_CASE_FITS } from "./data";
import FitBadge from "@/components/sections/alternatives/shared/fit-badge";

const MotionDiv = motion.div;

export default function OxylabsUseCaseFit() {
  const prefersReducedMotion = useReducedMotion();

  const fadeUp = (delay = 0) => ({
    initial: prefersReducedMotion ? {} : { opacity: 0, y: 24 },
    whileInView: prefersReducedMotion ? {} : { opacity: 1, y: 0 },
    viewport: scrollRevealViewport,
    transition: { duration: 0.55, delay },
  });

  return (
    <section className="py-section border-border border-b" aria-labelledby="use-case-fit-heading">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <MotionDiv {...fadeUp(0)} className="mb-14 max-w-2xl">
          <SectionHeader
            eyebrow="Use Case Fit"
            id="use-case-fit-heading"
            heading="Which provider fits your job?"
            body="Comparing vendors in the abstract is pointless. The right answer depends on what you're actually doing, so here's our honest read, use case by use case."
          />
        </MotionDiv>

        <div className="grid auto-rows-fr gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {USE_CASE_FITS.map((item, i) => (
            <MotionDiv
              key={item.useCase}
              {...fadeUp(Math.min(i * 0.05, 0.2))}
              className="bg-card card-wash card-hover border-border relative flex h-full flex-col gap-3 overflow-hidden rounded-2xl border p-6"
            >
              <h3 className="text-foreground relative text-base font-semibold">{item.useCase}</h3>
              <FitBadge fit={item.fit} />
              <p className="text-muted-foreground relative text-sm leading-relaxed">
                {item.reason}
              </p>
            </MotionDiv>
          ))}
        </div>
      </div>
    </section>
  );
}
